let env = process.env.REACT_APP_AMPLIFY_ENV;
const CLIENT_ID_DEV =
  "bcd4defb82ea80ad9a633eaa91e926aa.oauth-clients.spotfire.com"; // Development client ID
const CLIENT_ID_NON_DEV = "bd3b7f6cf9dcc0882afb6e6068dc96c3.oauth-clients.spotfire.com" //non development client ID

const sandboxLoginInfo = {
  domain: "sandbox.login.advantest.com",
  clientId: "QnSivuaNYdciHm4RbxasQIIFUxnIcLFl",
};

const prodLoginInfo = {
  domain: "login.advantest.com",
  clientId: "hb6r8l0A8GgS6hpcQjUGjT5MEFy9449S",
};

const isProdEnv = ["prod", "prodBackup"].includes(env);

export const myAdvaLogin = {
  ...(isProdEnv ? prodLoginInfo : sandboxLoginInfo),
  audience: "https://glasswall.advantest.com/",
};

const getApiURL = () => {
  switch (env) {
    case "prodBackup":
      return `https://api.prodBackup.glasswall.advantest.com`;
    case "prod":
      return "https://api.glasswall.advantest.com";
    case "local":
      return "http://localhost:8000";
    case "siemens":
    case "QA":
    case "dev":
    case "staging":
      return `https://api.${env.toLowerCase()}.glasswall.advantest.com`;
    default:
      return "https://api.glasswall.advantest.com";
  }
};

const getSpotfireClientId = () => {
  const currentEnv = env.toLowerCase();
  if (["siemens", "local"].includes(currentEnv)) {
    return CLIENT_ID_DEV;
  }
  return CLIENT_ID_NON_DEV;
}

export const baseUrl = getApiURL();
export const spotfireClientId = getSpotfireClientId();
export const spotfireOAuthJsPath = "/spotfire/js-api/oauth.js";
export const spotfireRedirectPath = "/spotfire-oauth-end.html";
export const spotfireApiVersion = "15.0";
export const spotfireBaseUrl = baseUrl + "/spotfire/wp";
